import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/menu/sidebar';
import TokenService from '../api/tokenService';
import EdizioneService from '../api/edizioneService';
import './admin.css';

const Admin = () => {
  const navigate = useNavigate();
  const username = TokenService.getUsername() || 'Utente';

  // Questa rotta non e' una pagina: e' il punto d'ingresso dopo il login e decide da dove si
  // comincia. L'edizione va scelta ogni volta, quindi quella rimasta da una sessione precedente si
  // butta e si passa dalla lista dei tornei: prima la rotta la buttava ma decideva ancora sul
  // valore vecchio, e si finiva dentro un torneo che le pagine non vedevano.
  useEffect(() => {
    if (!TokenService.isValidToken()) {
      navigate('/login');
      return;
    }

    EdizioneService.clear();
    navigate('/admin/tornei', { replace: true });
  }, [navigate]);
  
  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="admin-content">
        <div className="admin-container">
          <h1>Pannello Admin</h1>
          <p>Benvenuto, {username}!</p>
          <p>Seleziona una sezione dal menu laterale per iniziare.</p>
        </div>
      </div>
    </div>
  );
};

export default Admin;